import { html, ovl, SYSFormElement } from "../../../../../../../_ovlclient/src"
import { postRequest } from "../../../../../../../_ovlclient/src/effects"
import { DialogOk } from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  FieldIsActive,
  FieldIsVisible,
  FieldSetState,
  FieldSetVal,
  FieldVal,
  SYSField,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import {
  FormHasVisibleSummaryErrors,
  FormIsValid,
} from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { ValidationSummaryAdd } from "../../../../../../../_ovlclient/src/library/forms/validatorsapi"
import {
  ScreenNavigateBack,
  ScreenNavigateTo,
} from "../../../../../../../_ovlclient/src/library/screenapi"
import {
  SnackAdd,
  SnackTrackedAdd,
  SnackTrackedRemove,
} from "../../../../../../../_ovlclient/src/library/snackapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import { NewServiceStep2FormFieldKeys } from "../../../features/svl/svlnewservicestep2/formdef"
import { validateCaptcha } from "../../../global/helpers"

export class NewServiceStep2 extends SYSFormElement {
  newService: typeof this.state.app.global.SVL.NewService
  lookups: typeof this.state.app.global.SVL.lookups
  async init() {
    this.screen = "SVLNewServiceStep2"
    this.formType = "SVLNewServiceStep2"
    this.newService = this.state.app.global.SVL.NewService
    this.lookups = this.state.app.global.SVL.lookups
    await super.init()
  }

  async nextPage() {
    FieldSetState(this.formState.fields["objectLocationConfirmed"], false, {
      animate: "fade",
    })

    let apiUrl = this.state.ovl.apiUrl + "equipment/equipmentcheck"
    let token = await validateCaptcha()
    let res = await postRequest(apiUrl, {
      token,
      location: this.state.app.global.SVL.NewService.objectLocationParams,
    })
    if (res.data) {
      this.state.app.global.SVL.NewService.equipment.id = res.data.id
      ScreenNavigateTo("SVLNewServiceStep3")
    } else {
      SnackAdd(T("NewServiceDialogApiErrorRetry"), "Error", 6000)
    }
  }

  async handleStep2(e: Event) {
    // Basic Plan for Location Validation
    //   If Location Changed
    //   ValidateLocation
    //   If Adjusted
    //     Show Confirmation
    //     Return
    //   Else
    //     Check Equipment
    //     Next Page
    //   End If
    // End If
    // If Confirmation Set
    //   Check Equipment
    //   Next Page
    // End If
    // if (!FormValidate(this.formState)) {
    //   return
    // }
    let NewService = this.state.app.global.SVL.NewService
    NewService.slotFinder.zipCode =
      this.formState.fields["objectLocationZipCode"].convertedValue
    let street = this.formState.fields["objectLocationStreet"].convertedValue

    let zipCode = this.formState.fields["objectLocationZipCode"].convertedValue
    let city = this.formState.fields["objectLocationCity"].convertedValue
    let nr = this.formState.fields["objectLocationNr"].convertedValue

    // if (
    //   street !== NewService.objectLocationParams.Street ||
    //   (zipCode === undefined || zipCode === null ? "" : zipCode.toString()) !==
    //     NewService.objectLocationParams.ZipCode ||
    //   nr !== NewService.objectLocationParams.Nr ||
    //   city !== NewService.objectLocationParams.City
    // ) {
    // do a new location validate request
    NewService.objectLocationParams.Street = street
    NewService.objectLocationParams.ZipCode = zipCode
    if (NewService.objectLocationParams.ZipCode) {
      NewService.objectLocationParams.ZipCode =
        NewService.objectLocationParams.ZipCode.toString()
    }
    NewService.objectLocationParams.City = city
    NewService.objectLocationParams.Nr = nr
    NewService.objectLocationParams.NoResultsLink = ""
    NewService.objectLocationParams.MaxRange =
      this.state.app.global.SVL.lookups.problemType.data[
        NewService.selectedProblemType
      ]["MaxRange"]
    let res
    let snackId = SnackTrackedAdd(
      T("NewServiceSnackDataLoading"),
      "BusyIndicator"
    )
    try {
      let apiUrl = this.state.ovl.apiUrl + "location/validate"
      let token = await validateCaptcha()
      if (token) {
        NewService.objectLocationParams.RunNr = 0

        res = await postRequest(apiUrl, {
          token,
          location: NewService.objectLocationParams,
        })
      }
      NewService.objectLocationParams = res.data
      if (NewService.objectLocationParams.TooFar) {
        await DialogOk(T("NewServiceLocationOutOfRange"))
        window.location.replace(T("NewServiceLinkProcessFinishedRedirect"))
      }
      if (NewService.objectLocationParams.NoResultsLink) {
        ValidationSummaryAdd(
          this.formState,
          "NewServiceValidationAddressHelpLink",
          [NewService.objectLocationParams.NoResultsLink]
        )
        // SetFieldVisibility(
        //   this.formState.fields["objectLocationCity"],
        //   "fadeIn"
        // )
        return
      }
      if (NewService.objectLocationParams.Adjusted) {
        FieldSetVal(
          this.formState.fields["objectLocationStreet"],
          NewService.objectLocationParams.Street,
          { ignoreCustomValidation: true }
        )
        FieldSetVal(
          this.formState.fields["objectLocationZipCode"],
          NewService.objectLocationParams.ZipCode,
          { ignoreCustomValidation: true }
        )
        NewService.slotFinder.zipCode = FieldVal(
          this.formState.fields["objectLocationZipCode"]
        )
        FieldSetVal(
          this.formState.fields["objectLocationCity"],
          NewService.objectLocationParams.City,
          { ignoreCustomValidation: true }
        )
        // SetFieldVisibility(
        //   this.formState.fields["objectLocationCity"],
        //   "fadeIn"
        // )
        let confirm = this.formState.fields["objectLocationConfirmed"]

        await FieldSetVal(confirm, false)
        await FieldSetState(confirm, true, {
          animate: "fade",
          focusWhenVisible: true,
        })

        return
      } else {
        await this.nextPage()
      }
    } catch (res) {
      DialogOk(T("NewServiceDialogObjectLocationAPIError"))
      return
    } finally {
      SnackTrackedRemove(snackId)
    }
    // } else if (
    //   FieldIsVisible(this.formState.fields["objectLocationConfirmed"])
    // ) {
    //   let snackId
    //   try {
    //     snackId = SnackTrackedAdd(
    //       T("NewServiceSnackDataLoading"),
    //       "BusyIndicator"
    //     )
    //     await this.nextPage()
    //   } finally {
    //     SnackTrackedRemove(snackId)
    //   }
    // } else {
    //   ScreenNavigateTo("SVLNewServiceStep3")
    // }
  }

  async getUI() {
    let fields: { [key in NewServiceStep2FormFieldKeys]: SYSField } = <any>(
      this.formState.fields
    )

    let requesterFirstNameField = fields["requesterFirstName"]
    let requesterLastNameField = fields["requesterLastName"]

    let requesterTypeField = fields["requesterType"]

    let requesterCEmailField = fields["requesterCEmail"]
    let requesterCPhoneField = fields["requesterCPhone"]
    let requesterCFirstNameField = fields["requesterCFirstName"]
    let requesterCLastNameField = fields["requesterCLastName"]

    let objectLocationZipCodeField = fields["objectLocationZipCode"]
    let objectLocationCityField = fields["objectLocationCity"]
    let objectLocationStreetField = fields["objectLocationStreet"]
    let objectLocationNrField = fields["objectLocationNr"]
    let objectLocationNrConfirmationField = fields["objectLocationConfirmed"]

    //let newService = this.newService

    let requesterFirstName
    let requesterLastName
    let requesterType
    let requesterCFirstName
    let requesterCLastName
    let requesterCPhone
    let requesterCEmail
    let additionalContact

    if (FieldIsActive(requesterCFirstNameField)) {
      requesterCFirstName = html`
        <ovl-textbox .props=${() => requesterCFirstNameField}> </ovl-textbox>
      `
      requesterCLastName = html`
        <ovl-textbox .props=${() => requesterCLastNameField}> </ovl-textbox>
      `
      requesterCPhone = html`
        <ovl-textbox .props=${() => requesterCPhoneField}> </ovl-textbox>
      `
      requesterCEmail = html`
        <ovl-textbox .props=${() => requesterCEmailField}> </ovl-textbox>
      `
      additionalContact = html` <fieldset class="fd-fieldset fadeInControl">
        <legend class="fd-fieldset__legend">
          ${T("NewServiceRequesterC")}
        </legend>
        ${requesterCFirstName} ${requesterCLastName} ${requesterCPhone}
        ${requesterCEmail}
      </fieldset>`
    }

    let SummaryHint
    if (FormHasVisibleSummaryErrors(this.formState)) {
      SummaryHint = html`
        <ovl-formvalidationhint
          .props=${() => this.formState}
        ></ovl-formvalidationhint>
      `
    }

    let requester

    if (FieldIsActive(requesterFirstNameField)) {
      requesterFirstName = html`
        <ovl-textbox .props=${() => requesterFirstNameField}> </ovl-textbox>
      `
      requesterLastName = html`
        <ovl-textbox .props=${() => requesterLastNameField}> </ovl-textbox>
      `
      requesterType = html`
        <ovl-listcontrol .props=${() => requesterTypeField}> </ovl-listcontrol>
      `

      requester = html` <fieldset class="fd-fieldset">
        <legend class="fd-fieldset__legend">${T("NewServiceRequester")}</legend>
        ${requesterType} ${requesterFirstName} ${requesterLastName}
      </fieldset>`
    }

    let objectLocationConfirmation = html`
      <ovl-checkbox .props=${() => objectLocationNrConfirmationField}>
      </ovl-checkbox>
    `

    let objectLocationZipCode = html`
      <ovl-textbox .props=${() => objectLocationZipCodeField}> </ovl-textbox>
    `

    let objectLocationCity = html`
      <ovl-textbox .props=${() => objectLocationCityField}> </ovl-textbox>
    `

    let objectLocationStreet = html`
      <ovl-textbox .props=${() => objectLocationStreetField}> </ovl-textbox>
    `
    let objectLocationNr = html`
      <ovl-textbox .props=${() => objectLocationNrField}> </ovl-textbox>
    `
    return html`
      <div class="fd-layout-panel">
        <itf-newserviceheader></itf-newserviceheader>
        <div class="fd-layout-panel__body">
          ${requester} ${additionalContact}

          <fieldset class="fd-fieldset">
            <legend class="fd-fieldset__legend">
              ${T("NewServiceObjectLocation")}
            </legend>
            ${objectLocationStreet} ${objectLocationNr} ${objectLocationZipCode}
            ${objectLocationCity} ${objectLocationConfirmation}
          </fieldset>

          ${SummaryHint}
        </div>
        <div class="fd-layout-panel__footer itf-2-cols">
          <button
            class="fd-button"
            @click=${async (e) => {
              await ScreenNavigateBack()
            }}
          >
            ${T("NewServiceNavigateBack")}
          </button>
          <button
            class="fd-button"
            ?disabled=${!FormIsValid(this.formState)}
            @click=${(e) => this.handleStep2(e)}
          >
            ${T("NewServiceCreateServiceStep2")}
          </button>
        </div>
        <itf-newservicefooter></itf-newservicefooter>
      </div>
    `
  }
}
